import { httpClient } from '@/lib/http-client'

export const dataManagementApi = {
    /** Authenticated export — returns a Blob response */
    exportEntity: (entity: string, format: 'json' | 'csv' = 'json') =>
        httpClient.get(`/data-management/export`, {
            params: { entity, format },
            responseType: 'blob',
        }),

    /** Import data for a single entity or all entities */
    importEntity: (entity: string, form: FormData) =>
        httpClient.post(`/data-management/import?entity=${entity}`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),

    /** Factory reset — delete data by category (or all if empty) */
    factoryReset: (categories?: string[]) =>
        httpClient.post('/data-management/factory-reset', categories?.length ? { categories } : {}),

    // ── Backup & Restore ────────────────────────────────────────────

    /** List all backups */
    listBackups: () =>
        httpClient.get('/data-management/backups'),

    /** Create a new backup */
    createBackup: (payload: { name: string; description?: string; entities?: string[] }) =>
        httpClient.post('/data-management/backups', payload),

    /** Download a backup as ZIP */
    downloadBackup: (id: string) =>
        httpClient.get(`/data-management/backups/${id}/download`, {
            responseType: 'blob',
        }),

    /** Delete a backup */
    deleteBackup: (id: string) =>
        httpClient.delete(`/data-management/backups/${id}`),

    /** Restore from a backup */
    restoreBackup: (id: string) =>
        httpClient.post(`/data-management/backups/${id}/restore`),

    // ── Templates ────────────────────────────────────────────────────

    /** List built-in data templates */
    listTemplates: () =>
        httpClient.get('/data-management/backups/templates'),

    /** Import a built-in template */
    importTemplate: (filename: string) =>
        httpClient.post(`/data-management/backups/templates/${encodeURIComponent(filename)}/import`),

    // ── Storage config ───────────────────────────────────────────────

    /** Get current storage backend info */
    getStorageConfig: () =>
        httpClient.get('/data-management/backups/storage-config'),

    /** Update backup retention settings */
    updateRetentionPolicy: (payload: { max_count: number; max_age_days: number }) =>
        httpClient.post('/data-management/backups/retention', payload),
}
